import React, { useEffect, useState } from "react";
import "../styles/Header.css";

const navItems = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentSection, setCurrentSection] = useState(navItems[0].label);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll <= 0) {
        setIsScrolled(false);
        return;
      }

      if (currentScroll > lastScroll) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      setLastScroll(currentScroll);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScroll]);

  useEffect(() => {
    // Update current section based on scroll position
    const handleSectionChange = () => {
      let found = navItems[0].label;
      for (let i = 0; i < navItems.length; i++) {
        const el = document.getElementById(navItems[i].id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 80 && rect.bottom > 80) {
            found = navItems[i].label;
            break;
          }
        }
      }
      setCurrentSection(found);
    };
    window.addEventListener("scroll", handleSectionChange);
    return () => window.removeEventListener("scroll", handleSectionChange);
  }, []);

  const scrollToSection = (e, sectionId, label) => {
    e.preventDefault();
    document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
    setCurrentSection(label);
    setMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? "scroll-down" : "scroll-up"}`}>
      <nav className="nav-container">
        <div className="nav-links">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => scrollToSection(e, item.id, item.label)}
            >
              {item.label}
            </a>
          ))}
        </div>
        {/* Hamburger menu for mobile */}
        <div className="mobile-menu">
          <button
            className="menu-icon"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="Open navigation menu"
          >
            {/* SVG Hamburger Icon */}
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="6" width="28" height="3" rx="1.5" fill="#333" />
              <rect y="13" width="28" height="3" rx="1.5" fill="#333" />
              <rect y="20" width="28" height="3" rx="1.5" fill="#333" />
            </svg>
          </button>
          {menuOpen && (
            <div className="mobile-dropdown">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(e) => scrollToSection(e, item.id, item.label)}
                  className={currentSection === item.label ? "active" : ""}
                >
                  {item.label}
                </a>
              ))}
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
